module.exports = __webpack_public_path__ + "static/media/proposal-requests.57d84303.svg";